var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadReady)?_c('mdb-select',{attrs:{"multiple":_vm.multipleSelected,"options":_vm.labelOptions,"visibleOptions":6,"icon":"list","label":_vm.$t('category'),"placeholder":_vm.$t('choose_category')},on:{"getValue":_vm.getSelectValue}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }